
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('subtitleVod.vrun.component', () => import('./SubtitleVod.vue'))
